import noChatBG from "../../../Assets/Images/noChatBG.png";

export default function About() {
  return (
    <main
      className="w-full h-full bg-cover bg-center px-10 pb-10 pt-5 overflow-y-auto bg-[#f9f6fe] dark:bg-[#0b0c15]"
      style={{
        // backgroundImage: `url(${noChatBG})`, // Removed for cleaner dark mode
      }}
    >
      <div className="prose mx-auto max-w-4xl dark:prose-invert">
        <h1 className="text-center pb-3 dark:text-white">About App</h1>
        <h2 className='text-xl font-semibold'>1. Acceptance of Terms</h2>
        <p>
          By accessing and using this chat application, you agree to be bound by
          these Terms and Conditions. If you do not agree with any part of these
          terms, you may not use our services.
        </p>

        <h2 className='text-xl font-semibold'>2. User Conduct</h2>
        <p>Users must not:</p>
        <ul>
          <li>Engage in harassment, bullying, or hate speech</li>
          <li>Share illegal, harmful, or inappropriate content</li>
          <li>Impersonate others or create fake accounts</li>
          <li>Attempt to access unauthorized areas of the application</li>
          <li>Use the service for commercial purposes without permission</li>
        </ul>

        <h2 className='text-xl font-semibold'>3. Privacy and Data Protection</h2>
        <p>
          We are committed to protecting your privacy. Our Privacy Policy
          outlines how we collect, use, and protect your personal information.
          By using our service, you consent to our data practices.
        </p>

        <h2 className='text-xl font-semibold'>4. Content Ownership</h2>
        <p>
          Users retain ownership of their content but grant us a license to use,
          store, and display it within our service. We reserve the right to
          remove any content that violates these terms.
        </p>

        <h2 className='text-xl font-semibold'>5. Service Availability</h2>
        <p>
          We strive to maintain service availability but cannot guarantee
          uninterrupted access. We may perform maintenance or updates that
          temporarily affect service availability.
        </p>

        <h2 className='text-xl font-semibold'>6. Account Termination</h2>
        <p>
          We reserve the right to terminate or suspend accounts that violate
          these terms. Users may also terminate their accounts at any time.
        </p>

        <h2 className='text-xl font-semibold'>7. Limitation of Liability</h2>
        <p>
          We are not liable for any indirect, incidental, or consequential
          damages arising from the use of our service.
        </p>

        <h2 className='text-xl font-semibold'>8. Changes to Terms</h2>
        <p>
          We may modify these terms at any time. Continued use of the service
          after changes constitutes acceptance of the modified terms.
        </p>

        <h2 className='text-xl font-semibold'>9. Contact Information</h2>
        <p>
          For questions about these terms, please contact our support team
          through the help center.
        </p>
      </div>
    </main>
  );
}
